import React from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import { SecureHtml } from '@wix/wix-emails-secure-components';
import { WrapperItem } from '../components/wrapper-item';
import { Section } from '../components/section';
import { Text } from '../components/text';
import { Column } from '../components/column';
import { LinkWrapper } from '../components/link-wrapper';
import { shorthand } from '../utils/css-utils';
export function SectionAd(props) {
    const { section, cssClass, columnCssClass, isRtl, onAscendClick } = props;
    const adTextColor = '#fff';
    return (React.createElement(WrapperItem, null,
        React.createElement(Section, { backgroundColor: section.backgroundColor, borderBottom: section.borderBottom, borderLeft: section.borderLeft, borderRight: section.borderRight, borderTop: section.borderTop, cssClass: cssClass, padding: shorthand(section.outerPadding) },
            React.createElement(Column, { cssClass: columnCssClass, padding: shorthand(section.innerPadding) },
                React.createElement(Text, { align: "center", color: adTextColor, containerBackgroundColor: "#2a2c2e", fontFamily: "helvetica,sans-serif", fontSize: "14px", padding: "12px 10px", lineHeight: "18px" },
                    React.createElement("div", { style: { direction: isRtl ? 'rtl' : undefined } },
                        React.createElement("span", { style: {
                                color: adTextColor,
                                padding: '5px 0px 5px 0px',
                            } },
                            React.createElement(AdText, { translationKey: "COMPOSER.FOOTER.EM.AD.CREATED_BY" })),
                        React.createElement("span", null, "\u200C\u00A0"),
                        React.createElement("a", { style: {
                                color: adTextColor,
                                textDecoration: 'underline',
                                display: 'inline-block',
                            }, 
                            // referralInfo, utm_campaign parameters are sent in both cases:
                            // 1 - to be backwards compatible
                            // 2 - to have ability detecting if user visited wix from email marketing
                            // 3 - we don't need to detect if it was clicked from within email, landing page, etc
                            href: "https://www.wix.com?utm_campaign=vir_promote_em_footer_wixads&referralInfo=SO_LP", target: "_blank", rel: "noopener noreferrer", onClick: onAscendClick },
                            React.createElement(LinkWrapper, null,
                                React.createElement(AdText, { translationKey: "COMPOSER.FOOTER.EM.AD.EXPLORE_MORE" })))))))));
}
function AdText({ translationKey }) {
    const { t } = useTranslation();
    return (React.createElement(SecureHtml, { containerProps: {
            style: {
                wordBreak: 'keep-all',
            },
        }, html: t(translationKey).replace(/ /g, '&nbsp;'), as: "span", skipCleaning: true }));
}
//# sourceMappingURL=section-ad.js.map